import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreReducers, CoreState, pictureService } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { IParkBindTableNameEnum } from "@reco-w/common-common";
import { Namespaces as commonNamespaces } from "@reco-w/common-models";
import { spaceParkHttpService, organizationParkHttpService } from "@reco-w/impression-service";

import { Namespaces } from "./common";

export namespace impressionModel {
    export const namespace = Namespaces.impression;

    export type StateType = typeof state;

    export const state: any = freeze(
        {
            ...CoreState,
            showloading: true,
            open: false,
        },
        !0
    );

    export const reducers: ReducersMapObject = {
        ...CoreReducers,

        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,

        *initPage({ message, parkCode, callback }, { call, put }) {
            try {
                yield put({ type: "initState" });
                yield put({ type: `${commonNamespaces.cmsCommon}/getHeadJson`, location: "/impression", message });
                yield put({ type: "getParkNum", parkCode, message, callback });
                yield put({ type: "getAMapConfig", message });
            } catch (e) {
                yield call(message!.error, "initPage：" + e.errmsg);
            }
        },

        /**
         * 获取园区详情
         */
        *getParkDetailAction({ inpree, message, callback }, { call, put }) {
            try {
                const data = yield call(spaceParkHttpService.get, inpree);

                if (data && data.id) {
                    yield put({ type: "getParkPicturesAction", id: data.id, message, callback });
                }

                yield put({
                    type: "input",
                    data: {
                        parkImpressionDetailData: data,
                    },
                });
            } catch (e) {
                yield call(message!.error, "该园区暂无详情");
            }
        },

        /**
         * 获取园区图片
         */
        *getParkPicturesAction({ message, id, callback }, { call, put }) {
            try {
                const data = yield call(pictureService.getPictureUrls, {
                    bindTableName: IParkBindTableNameEnum.space,
                    bindTableId: id,
                });

                yield put({
                    type: "input",
                    data: {
                        parkPictureAsync: data || [],
                    },
                });

                if (callback) {
                    yield call(callback);
                }
            } catch (e) {
                yield call(message?.error, "getParkPicturesAction：" + e.errmsg);
            }
        },

        /**
         * 获取所有园区
         */
        *getParkNum({ message, parkCode, callback }, { call, put }) {
            try {
                yield put({ type: "showLoading" });
                const parks = yield call(organizationParkHttpService.getPaged);

                let parkName: any = [];

                parks.items?.forEach((item, i) => {
                    const data = {
                        id: item.id,
                        type: `${i}`,
                        title: item.parkName,
                        code: item.parkCode,
                        shortName: item.shortName,
                        units: item.units,
                        isValid: item.isValid,
                    };
                    parkName.push(data);
                });

                const parkNow = parkName.find((x) => x.code === parkCode);

                parkName = parkName.filter((x) => x.code !== parkCode);

                yield put({ type: "getParkDetailAction", inpree: parkNow?.id, message, callback });

                yield put({
                    type: "input",
                    data: { parkName },
                });
            } catch (e) {
                yield call(message!.error, "getParkNum：" + e.errmsg);
            } finally {
                yield put({ type: "hideLoading" });
            }
        },

        /**
         * 获取高德配置
         * @param { message }
         * @param { call }
         */
        *getAMapConfig({ message }, { call, put, select }) {
            try {
                yield yield put({ type: `${commonNamespaces.configCommon}/getAMapConfig` });
                const configState: any = yield select((state) => state[commonNamespaces.configCommon]),
                    isShowMap = configState!.isShowMap;

                yield put({ type: "input", data: { isShowMap } });
            } catch (e) {
                yield call(message!.error, "getAMapConfig：" + e.errmsg);
            }
        },
    };
}

app.model(impressionModel);
